export default __webpack_public_path__ + "static/media/location.d077fbe0.svg";